import React, { useEffect, useRef } from 'react';
import * as bootstrap from 'bootstrap';

export default ({ children, footer, onClose, size = 'lg', title = 'Confirm' }) => {
	const isShown = useRef(false);
	const modalDOMRef = useRef();
	const modalRef = useRef();

	useEffect(() => {
		if (isShown.current) return;
		isShown.current = true;
		modalRef.current = new bootstrap.Modal(modalDOMRef.current);
		modalRef.current._element.addEventListener('hidden.bs.modal', () => {
			onClose && onClose();
		});
		modalRef.current.show();
	}, [modalDOMRef.current]);

	return (
		<div className="modal" ref={modalDOMRef} tabIndex="-1">
			<div className={`modal-dialog modal-${size} modal-dialog-centered`}>
				<div className="modal-content">
					<div className="modal-header">
						{title && <h5 className="modal-title w-100">{title}</h5>}
						<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div className="modal-body">
						{children}
					</div>
					<div className="modal-footer">
						{footer}
					</div>
				</div>
			</div>
		</div>
	);
};
